import SustainabilityAndCommunity from "./SustainabilityAndCommunity"

export default SustainabilityAndCommunity
